//imports
import React, { useState, useRef, useEffect, Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ToggleLanguage from "Components/ToggleLanguage";

//controls
import { Form, Input, Loading, Button } from "Components";
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { Box, Container, Grid } from "@mui/material";
import { ErrorHandlerLogin } from "Core/data/Helpers";
import { NotificationManager } from 'Components/Notifications';

//components
import "Core/views/login/login.scss";

//actions
import {
    loginSetError,
    clearRedux,
    getResellerInfo
} from "Redux/actions";


import { verifyUserRequest, reset, setError, codeVerificationRequest, forgotPasswordConfirmRequest } from "./redux/slice";

//components
import LoginLogo from "../common/LoginLogo";
import FooterResellers from "../common/FooterResellers";
import AgreementMessage from "../common/AgreementMessage";
import ForgotPwdLink from "../common/ForgotPwdLink";
import ChatWithSupport from "../common/ChatWithSupport";
import DOMPurify from "dompurify";

import { validateStrongPassword } from "../../data/Helpers";

const confirmUserView = (props) => {
    const { messages } = useIntl();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { isResetPassword } = props

    const {
        loading,
        error,
        showConfirm,
        result
    } = useSelector((state) => state.confirmUserRedux);

    const { loginPage, loading: loadingSignIn, cognitoValues } = useSelector((state) => state.loginRedux);
    const { current_reseller, reseller_was_validated } = useSelector((state) => state.resellerRedux);

    // confirmUser?email=ronalcamilo@gmail.com&username=ronalcamilo@gmail.com&confirmationCode=447774&action=verifyEmail
    // resetPassword?email=ronalcamilo@gmail.com&confirmationCode=677538&action=forgotPassword
    //https://scr.gpstrackit.com/confirmUser?email=ronal.cuellar@outlook.com&username=ronal.cuellar@outlook.com&confirmationCode=589096&authId=PX_5773_2000227486&action=verifyEmail

    const queryParams = new URLSearchParams(location.search);
    const username = queryParams.get('username');
    const email = queryParams.get('email');
    const confirmationCode = queryParams.get('confirmationCode');
    // const action = queryParams.get('action');
    const authId = queryParams.get('authId');

    const [password, setPassword] = useState("");
    const [txtConfirmPassword, setTxtConfirmPassword] = useState("");


    const frmConfirmUser = useRef();
    const frmForgotConfirm = useRef();

    const urlImgLogo = current_reseller
        ? current_reseller?.loginCompanyLogo
        : "/assets/images/verticalLogo.png";

    let { reseller } = useParams();

    useEffect(() => {
        //didmount
        return () => {
            dispatch(reset());
        };
    }, []);


    useEffect(() => {
        if (reseller) {
            //// checking reseller by key and by name in the url
            dispatch(getResellerInfo("key", reseller));
        } else if (!current_reseller) {
            // check if the current domain corresponds to a reseller
            const hostname = window.location.hostname;
            dispatch(getResellerInfo("domain", hostname));
        }
    }, [reseller]);

    useEffect(() => {
        if (confirmationCode) {
            dispatch(codeVerificationRequest({ username: username || email, code: confirmationCode, navigate, isResetPassword, authId }))
        }

        dispatch(reset({ confirmationCode: null }));
    }, [confirmationCode]);

    useEffect(() => {
        if (result) {
            if (!result.isValid) {
                NotificationManager.error(
                    messages[`confirmUser_codeNotValid`],
                    messages['error'],
                    4000,
                    null,
                    null,
                    'Error',
                );

                navigate('/login');
            }
            else {

                if (isResetPassword) {
                    NotificationManager.success(
                        messages[result.message || ""],
                        messages['confirmUser_passwordReset'],
                        4000,
                        null,
                        null,
                        'success',
                        null
                    );
                }
                else {
                    // NotificationManager.success(
                    //     messages[result.message || ""],
                    //     messages['confirmUser_verifyCode'],
                    //     4000,
                    //     null,
                    //     null,
                    //     'success',
                    //     null
                    // );
                    dispatch(loginSetError(result.message))
                }
                navigate('/login');
            }
        }

        dispatch(reset({ result: null }));
    }, [result]);

    useEffect(() => {
        if (cognitoValues) {
            navigate("/")
            dispatch(clearRedux("LOGIN"));
        }
    }, [cognitoValues]);

    const handleClose = () => {
        // dispatch(migrateUserConfirmClose());
    };
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            className="all-space-container"
        >
            <Grid
                item
                xs={12}
                lg={5}
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                }}
            >
                <Box
                    style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "end",
                        margin: "20px 25px 0 0px",
                    }}
                >
                    <ToggleLanguage className="btn-white" />
                </Box>

                <div className="background-white-login" style={{ paddingTop: 10, height: "100%", width: "500px", display: "flex", alignItems: "center" }}>
                    <Container className="form-login-container">
                        {reseller_was_validated && <LoginLogo urlImgLogo={urlImgLogo} />}
                        {error && (
                            <div className="form-item card-error-login">
                                <p className="txt-card-error-login">
                                    {messages[ErrorHandlerLogin(error)] ||
                                        ErrorHandlerLogin(error)}
                                </p>
                            </div>
                        )}

                        <p>{messages["confirmUser_passwordRecovery"]}</p>
                        <Form
                            ref={frmConfirmUser}
                            onSubmit={() => {
                                if (!validateStrongPassword(password)) {

                                    NotificationManager.error(
                                        messages["accountChangePassword_passwordValidation"],
                                        messages["error"],
                                        3500,
                                        null,
                                        null,
                                        "error"
                                    )
                                    return false
                                }

                                if (password != txtConfirmPassword) {

                                    NotificationManager.error(
                                        messages["confirmUser_passwordDoesNotMatch"],
                                        messages["error"],
                                        3500,
                                        null,
                                        null,
                                        "error"
                                    )
                                    return false
                                }

                                return true
                            }}
                            onValidSubmit={() => {
                                setError(null);
                                if (password != txtConfirmPassword) {
                                    dispatch(setError(messages['confirmUser_passwordDoesNotMatch']))
                                } else {
                                    if (isResetPassword) {
                                        dispatch(forgotPasswordConfirmRequest({
                                            username: email, confirmationCode, password, confirmPassword: txtConfirmPassword
                                        }));

                                    } else {
                                        dispatch(verifyUserRequest({ username, code: confirmationCode, password, navigate, authId }));
                                    }

                                }
                            }}
                        >
                            {(loading || loadingSignIn) ? (
                                <div className="loading-area">
                                    <Loading />
                                </div>
                            ) : (
                                <>
                                    <div>
                                        <Input
                                            id="txtUsername"
                                            disabled
                                            type="text"
                                            className="txt-username"
                                            label={""}
                                            placeholder={messages["confirmUser_currentUsername"]}
                                            value={username || email}
                                            onChange={() => { }}
                                            required
                                            requiredMessage={messages["required_field"]}
                                            autoFocus
                                        />
                                    </div>
                                    <div>
                                        <Input
                                            id="txtPassword"
                                            label={""}
                                            placeholder={messages["confirmUser_password"]}
                                            value={password}
                                            type="password"
                                            onChange={(text) => {
                                                setPassword(text);
                                            }}
                                            required
                                            requiredMessage={messages["required_field"]}
                                            autoFocus
                                        />
                                    </div>
                                    <div>
                                        <Input
                                            id="txtConfirmPassword"
                                            type="password"
                                            label={""}
                                            placeholder={messages["confirmUser_confirmPassword"]}
                                            value={txtConfirmPassword}
                                            onChange={(text) => {
                                                setTxtConfirmPassword(text);
                                            }}
                                            required
                                            requiredMessage={messages["required_field"]}
                                            autoFocus
                                        />
                                    </div>
                                    <div style={{ paddingTop: 10 }}>
                                        {loading ? (
                                            <div className="loading-area">
                                                <Loading />
                                            </div>
                                        ) : (
                                            <Button
                                                id="btnContinue"
                                                className="btn btn-blue btn-block"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    frmConfirmUser.current.submit();
                                                }}
                                            >
                                                {messages["confirmUser_login"]}
                                            </Button>
                                        )}
                                    </div>
                                    <div style={{ paddingTop: 10 }}>
                                        <Button
                                            id="btnBack"
                                            className="btn btn-gray btn-block"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(-1);
                                            }}
                                        >
                                            {messages["confirmUser_cancel"]}
                                        </Button>
                                    </div>
                                    <Box style={{ margin: "25px 0 0 0" }}>
                                        <ForgotPwdLink current_reseller={current_reseller} />
                                    </Box>
                                    <Box style={{ margin: "5px 0 0 0" }}>
                                        <ChatWithSupport />
                                    </Box>
                                </>
                            )}
                        </Form>
                    </Container>
                </div>
                {!current_reseller && <AgreementMessage />}

                <Modal
                    title={messages["confirmUser_emailVerification"]}
                    open={showConfirm || false}
                    handleClose={handleClose}
                    size="small"
                >
                    <ModalBody>
                        <div style={{ padding: 20 }}>
                            {error && (
                                <div className="form-item card-error-login login-code-error">
                                    <p className="txt-card-error-login">
                                        {messages[ErrorHandlerLogin(error)] ||
                                            ErrorHandlerLogin(error)}
                                    </p>
                                </div>
                            )}

                            <div>
                                <br />
                                {messages["confirmUser_verifyTex"]}
                            </div>
                            {result && (
                                messages["confirmUser_success"]
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {(loading || loadingSignIn) ? (
                            <div className="loading-area">
                                <Loading />
                            </div>
                        ) : (
                            <Fragment>
                                {result ? (
                                    <Button
                                        id="btnContinueConfirm"
                                        type="link"
                                        url="/login"
                                        className="btn btn-blue"
                                    >
                                        <FormattedMessage id="continue" />
                                    </Button>
                                ) : (
                                    <Fragment>
                                        <Button
                                            id="btnCloseConfirm"
                                            onClick={handleClose}
                                            className="btn-cancel"
                                        >
                                            {messages["close"]}
                                        </Button>
                                        {"  "}
                                        <Button
                                            id="btnConfirm"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                frmForgotConfirm.current.submit();
                                            }}
                                            className="btn-blue"
                                        >
                                            {messages["confirmUser_verify"]}
                                        </Button>
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </ModalFooter>
                </Modal>
                <Box style={{ margin: "25px", width: "100%", textAlign: "center" }}>
                    {current_reseller && (
                        <FooterResellers current_reseller={current_reseller} />
                    )}
                </Box>
            </Grid>
            <Grid item xs={12} lg className="all-space-container">
                {(loginPage && current_reseller?.code === "zonar") ? (
                    <div
                        className="all-space-container overflow-auto"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(loginPage) }}
                    />
                ) : (
                    <div
                        className="login_bg"
                        style={{
                            backgroundImage: reseller_was_validated
                                ? (!current_reseller?.loginBackgroundImage && current_reseller?.loginBackgroundColor) ? `none`
                                    : `url(${current_reseller?.loginBackgroundImage ||
                                    "/assets/images/loginbg-dark.png"
                                    })`
                                : "",
                            backgroundColor: (!reseller_was_validated || current_reseller?.loginBackgroundImage) ? "transparent"
                                : (current_reseller?.loginBackgroundColor || "transparent")
                        }}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default confirmUserView;